import { Button, Box } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
interface MyType {
    Rfq_Details: {};
    Part_Details: {};
    expiryDate: string;
    previousExpiryDate: string;
    addedTime: string;
}
interface FooterProps {
    activeStep: number;
    handleBack: () => void;
    handleNext: () => void;
    stepsLength: number;
    MM_RFQ_FORM_DATA: MyType[];
}

export const BtnFooter = ({
    activeStep,
    handleBack,
    handleNext,
    stepsLength,
    MM_RFQ_FORM_DATA
}: FooterProps) => {
    const location = useLocation();
    const locationData = location?.state;
    const isPartnerAdded =
        MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.selectedVendors?.filter(
            (item) =>
                !MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.previousSelectedVendors.includes(
                    item
                )
        );
    return (
        <Box mt={2} sx={{ display: "flex", justifyContent: "end" }}>
            <Button
                variant="outlined"
                // disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ marginRight: "10px" }}
            >
                {locationData?.from === "EditDueDateOfMMrfq" ||
                locationData?.from === "addPartnerForMMrfq"
                    ? "Cancel"
                    : "Back"}
            </Button>
            {activeStep === stepsLength - 1 ? (
                <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={
                        (locationData?.from === "EditDueDateOfMMrfq" &&
                            MM_RFQ_FORM_DATA[0]?.expiryDate ==
                                MM_RFQ_FORM_DATA[0]?.previousExpiryDate) ||
                        (isPartnerAdded?.length <= 0 &&
                            locationData?.from === "addPartnerForMMrfq")
                    }
                >
                    Submit
                </Button>
            ) : (
                <Button variant="contained" onClick={handleNext}>
                    Next
                </Button>
            )}
        </Box>
    );
};
